module.exports = __webpack_public_path__ + "static/media/screen3.6e772094.jpeg";